var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHospitalBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 248,
    y1: 766,
    x2: 248,
    y2: 382,
    gradientTransform: "matrix(1 0 0 1 0 -270)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BAF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006DF0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M496,256v-32c0-17.6-14.4-32-32-32H360v-80h-40v16h24v352h-32V360c0-13.2-10.8-24-24-24h-80 c-13.2,0-24,10.8-24,24v120h-32V128h24v-16h-40v80H32c-17.6,0-32,14.4-32,32v32h24v224H0v16h496v-16h-24V256H496z M464,208 c8.8,0,16,7.2,16,16v16H360v-32H464z M424,304v32h-32v-32H424z M376,336h-16v-32h16V336z M424,384v32h-32v-32H424z M376,416h-16v-32 h16V416z M296,360v120h-40v-56h16v-16h-16v-56h32C292.4,352,296,355.6,296,360z M200,360c0-4.4,3.6-8,8-8h32v56h-16v16h16v56h-40 V360z M72,416v-32h32v32H72z M120,384h16v32h-16V384z M72,336v-32h32v32H72z M120,304h16v32h-16V304z M16,224c0-8.8,7.2-16,16-16 h104v32H16V224z M40,256h96v32H56v64h80v16H56v64h80v48H40V256z M456,480h-96v-48h80v-64h-80v-16h80v-64h-80v-32h96V480z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 248,
    y1: 574,
    x2: 248,
    y2: 510,
    gradientTransform: "matrix(1 0 0 1 0 -270)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0095F0"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168,304h160v-64H168V304z M232,288v-32h32v32H232z M312,288h-32v-32h32V288z M184,256h32v32h-32V256z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 248,
    y1: 494,
    x2: 248,
    y2: 430,
    gradientTransform: "matrix(1 0 0 1 0 -270)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0080F0"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M328,160H168v64h160V160z M264,176v32h-32v-32H264z M184,176h32v32h-32V176z M312,208h-32v-32h32V208z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 248,
    y1: 414,
    x2: 248,
    y2: 302,
    gradientTransform: "matrix(1 0 0 1 0 -270)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0091F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006DF0"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M224,144h48v-32h32V64h-32V32h-48v32h-32v48h32V144z M208,96V80h32V48h16v32h32v16h-32v32h-16V96H208z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalBlue);
export default __webpack_public_path__ + "static/media/hospital-blue.b34d319f759abddac2956bbf8fa272d9.svg";
export { ForwardRef as ReactComponent };